var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{class:{'badge-state': true, [_vm.bg]: true}},[(_vm.icon)?_c('i',{staticClass:"icon",class:{[_vm.icon]: true, 'mr-5': !!_vm.msg}}):_vm._e(),_vm._v(_vm._s(_vm.msg)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }